import { render, staticRenderFns } from "./setupEmployeePassword.vue?vue&type=template&id=2dd3005c&scoped=true"
import script from "./setupEmployeePassword.vue?vue&type=script&lang=js"
export * from "./setupEmployeePassword.vue?vue&type=script&lang=js"
import style0 from "./setupEmployeePassword.vue?vue&type=style&index=0&id=2dd3005c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3005c",
  null
  
)

export default component.exports